import Http from '../../common/services/Http';
import { Paged } from '../common/types/Page';
import { SelectValueLabelIsSystem } from 'common/types/SelectValueLabel';
import { InsuranceContractTypeDto, InsuranceContractTypeIconDto } from './models/InsuranceContractTypeDto';
import { InsuranceContractTypesSearchCriteria } from './models/InsuranceContractTypesSearchCriteria';

class InsuranceContractTypesService {
    public getList(criteria: InsuranceContractTypesSearchCriteria) {
        return Http.get<Paged<InsuranceContractTypeDto>>('insurancecontracttypes', criteria);
    }

    public catalog() {
        return Http.get<SelectValueLabelIsSystem[]>('insurancecontracttypes/catalog');
    }

    public catalogIcons() {
        return Http.get<InsuranceContractTypeIconDto[]>('insurancecontracttypes/icons-catalog');
    }

    public getById(id: string) {
        return Http.get<InsuranceContractTypeDto>('insurancecontracttypes/' + id);
    }

    public create(model: InsuranceContractTypeDto) {
        return Http.post<string>('insurancecontracttypes', model);
    }

    public update(model: InsuranceContractTypeDto) {
        return Http.put('insurancecontracttypes', model);
    }

    public remove(model: InsuranceContractTypeDto) {
        return Http.put('insurancecontracttypes/deactivate', model);
    }
}

export default new InsuranceContractTypesService();
